import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as adminActions from '../actions/adminActions';

function CiscoChat(props, actions) {
    const contactIFMUrl = 'http://www.indianafarmers.com/about-us/contact-us/';
    const ciscoUrl =
        'https://home-c36.nice-incontact.com/incontact/chatclient/chatclient.aspx?poc=77c54461-8911-4481-a714-a6c2a2811136&bu=4601522';
    
    const [chatClickValidated, setChatClickValidated] = useState(true);
    const [chatInitiallyValidated, setChatInitiallyValidated] = useState(false);

    const evaluateChatSchedule = useCallback(async () => {
        const currentDate = new Date();
        var result = await props.actions.fetchChatOptions();

        const chatSchedule = result.response;

        var chatAvailable = true;

        if (chatSchedule != null) {
            switch (chatSchedule.mode) {
            case 1:
                chatAvailable = true;
                break;
            case 2:
                chatAvailable = false;
                break;
            case 3:
                {
                    // check the weekend status
                    const dayOfWeek = currentDate.getDay();
                    const isWeekend = (dayOfWeek === 6) || (dayOfWeek === 0); // 6 = Saturday, 0 = Sunday

                    chatAvailable = !(isWeekend && chatSchedule.closedWeekends);

                    // check the time
                    if (chatAvailable) {
                        const chatScheduleStart = new Date(chatSchedule.startTime);
                        const chatScheduleEnd = new Date(chatSchedule.endTime);

                        const chatDailyStart = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), chatScheduleStart.getHours(), chatScheduleStart.getMinutes(), chatScheduleStart.getSeconds(), chatScheduleStart.getMilliseconds());
                        const chatDailyEnd = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), chatScheduleEnd.getHours(), chatScheduleEnd.getMinutes(), chatScheduleEnd.getSeconds(), chatScheduleEnd.getMilliseconds());

                        chatAvailable = currentDate.getTime() > chatDailyStart.getTime() && currentDate.getTime() < chatDailyEnd.getTime();
                    }
                }
                break;
            }
        }

        return chatAvailable;
    }, [actions]);

    // fired when loaded
    const initialChatAvailable = useMemo(async() => {
        const canChat = await evaluateChatSchedule();
        setChatInitiallyValidated(canChat);
    }, []);

    // fired when clicked
    const onChat = useCallback(async () => {
        try {
            const response = await evaluateChatSchedule();

            if (response) {
                window.open(ciscoUrl, '_blank');
            }
            setChatClickValidated(response);
        } catch {}
    }, []);
  
    return (
		<div className='ciscoChat'>
			<div className='title'>Need Help?</div>
            {
                chatInitiallyValidated ? (
                    <div>
                        <div className='body'>Chat live with a member of our staff.</div>
                        {chatClickValidated&& (
                            <a onClick={onChat} href='#' rel='noopener noreferrer'>
                                <Icon name='comment' />
                                CHAT
                            </a>
                        )}  
                        {!chatClickValidated && (<div style={{ color: 'red' }}>We're sorry. Chat is not available at this time.</div>)}
                    </div>
                ) : null}

            <div>
                <div className='body'>Leave a comment or question.</div>
                <a href={contactIFMUrl} target='_blank' rel='noopener noreferrer'>
                    <Icon name='mail outline' />
                    Mail
                </a>
            </div>
        </div>
    );
}

CiscoChat.propTypes = {
   // admin: PropTypes.object.isRequired
};

const mapDispatchToProps = (dispatch) => ({
    actions: {
        ...bindActionCreators(adminActions, dispatch),
    }
});

export default connect(null, mapDispatchToProps)(CiscoChat);